import React from 'react';
import ButtonModal from '../button/ButtonModal';
import i18n from '../../../config/I18n';
import imgModalError from '../../assets/svg/iconClock.svg';
import './modal.css';

const volverPortalPrivado = () => {
  window.top.location.href = process.env.URL_PORTAL_PRIVADO;
};

const ModalErrorGenerico = (props) => props.visible && (
  <div className="Modal">
    <div className="Modal__container">
      <div className="container modal">

        <div className="row">
          <div className="col">
            <img src={imgModalError} className="iconModalError" alt="svg" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h2 className="titleModal">{i18n.t('ui.errorGenerico01')}</h2>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <p>{i18n.t('ui.errorGenerico02')}</p>
            {!props.wv && (
              <ButtonModal
                buttonName={i18n.t('ui.errorGenerico03')}
                callFunction={volverPortalPrivado}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

ModalErrorGenerico.defaultProps = {
  visible: true
};

export default ModalErrorGenerico;